import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import routeConstant from '../../../../lib/constants/routeConstant';
import { feedbackButtonStyles as styles } from './feedbackButton.style';
import FeedbackModal from '../../Modals/FeedbackModal/FeedbackModal';
import Button from "../../../shared/Button/Button";

const FeedbackButton = () => {
    const location = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);

    // List of routes where the feedback button should NOT be shown
    const hideOnRoutes = [
        routeConstant.LOGIN_PAGE,
        routeConstant.SIGNUP_PAGE,
        routeConstant.SPORT_PAGE,
        routeConstant.FORGOT_PASSWORD_PAGE,
        routeConstant.VERIFY_OTP_PAGE,
        routeConstant.CREATE_PASSWORD_PAGE
    ];

    // Check if current path matches any of the hidden routes (using prefix matching for dynamic routes)
    const shouldHide = hideOnRoutes.some(route => location.pathname.startsWith(route));

    if (shouldHide) return null;

    return (
        <>
            <Button
                variant="primaryOutlined"
                className={styles.button}
                onClick={() => setIsModalOpen(true)}
                aria-label="Have Feedback?"
            >
                Have Feedback?
            </Button>

            <FeedbackModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </>
    );
};

export default FeedbackButton;
